module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("cPLJH"))).then(() => parcelRequire('kCX5c'));